import { render, staticRenderFns } from "./DeleteProfile.vue?vue&type=template&id=4293ac7e"
import script from "./DeleteProfile.vue?vue&type=script&lang=js"
export * from "./DeleteProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports